/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientFirstSessionDto = {
    /**
     * Scheduled start time of the first session
     */
    scheduledStartTime?: string | null;
    /**
     * Status of the first session
     */
    status: ClientFirstSessionDto.status | null;
};
export namespace ClientFirstSessionDto {
    /**
     * Status of the first session
     */
    export enum status {
        SCHEDULED = 'scheduled',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        RESCHEDULED = 'rescheduled',
    }
}

